import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const TrialExpiredMessage = ({ 
  onUpgradeClick, 
  variant = 'default', // 'default', 'compact', 'inline'
  showButton = true,
  className = '',
  trialDurationDays = null // Optional prop for dynamic trial duration
}) => {
  const baseClasses = "bg-gradient-to-r from-red-50 to-rose-50 border border-red-200 rounded-lg";
  
  // Create dynamic message based on trial duration
  const getTrialMessage = () => {
    if (trialDurationDays) {
      return `Your ${trialDurationDays}-day free trial has ended. Upgrade to continue using Bela.`;
    }
    return 'Your free trial has ended. Upgrade to continue using Bela.';
  };

  const getTrialMessageLong = () => {
    if (trialDurationDays) {
      return `Your ${trialDurationDays}-day free trial has ended. Upgrade to premium to continue chatting with Bela.`;
    }
    return 'Your free trial has ended. Upgrade to premium to continue chatting with Bela.';
  };
  
  if (variant === 'inline') {
    return (
      <div className={`${baseClasses} p-4 mb-4 shadow flex-shrink-0 ${className}`} role="alert">
        <p className="font-bold text-red-700">Trial Expired</p>
        <p className="text-sm mb-2 text-black font-normal">
          {getTrialMessageLong()}
        </p>
        {showButton && onUpgradeClick && (
          <button
            onClick={onUpgradeClick}
            className="bg-bela-600 hover:bg-bela-700 text-white text-sm font-semibold py-2 px-4 rounded transition-colors"
          >
            Upgrade Now
          </button>
        )}
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className={`${baseClasses} p-3 ${className}`}>
        <div className="flex items-center gap-2 text-red-700 mb-2">
          <FiAlertTriangle className="text-red-500" size={16} />
          <span className="font-semibold text-sm">Trial Expired</span>
        </div>
        <div className="space-y-1">
          <p className="text-xs text-black font-normal">
            {getTrialMessage()}
          </p>
        </div>
        {showButton && onUpgradeClick && (
          <button
            onClick={onUpgradeClick}
            className="mt-3 w-full bg-bela-600 hover:bg-bela-700 text-white text-xs font-semibold py-2 px-3 rounded transition-colors"
          >
            Upgrade Now
          </button>
        )}
      </div>
    );
  }

  // Default variant (for AccountModal)
  return (
    <div className={`${baseClasses} p-3 ${className}`}>
      <div className="flex items-center gap-2 text-red-700 mb-2">
        <FiAlertTriangle className="text-red-500" size={18} />
        <span className="font-semibold">Trial Expired</span>
      </div>
      <div className="space-y-1">
        <p className="text-sm text-black font-normal">
          {getTrialMessage()}
        </p>
      </div>
      {showButton && onUpgradeClick && (
        <button
          onClick={onUpgradeClick}
          className="mt-3 w-full bg-bela-600 hover:bg-bela-700 text-white text-sm font-semibold py-2 px-3 rounded transition-colors"
        >
          Upgrade Now
        </button>
      )}
    </div>
  );
};

export default TrialExpiredMessage;
